import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import {
  Grid,
  GridColumn,
  GridNoRecords,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import { Splitter } from "@progress/kendo-react-layout";
import { Popup } from "@progress/kendo-react-popup";
import { formatDateForAPI } from "components/common/formatter.js";
import {
  getDocument,
  downloadDocumentAsPDF,
  downloadDocument,
  getDocumentEditor,
  getMatterDocDuplicate,
  getMattersdetails,
  getSingleMatterActivity,
  updateMatterActivity,
  downloadDocumentsAsZip,
} from "api/index";
import { getBillingRequestDetails } from "services/billingRequestsService";
import { getAccessRightsData } from "services/currentUserService";

import DocumentViewer from "components/common/DocumentViewer";
import { fileIcon } from "components/common/fileIcon";
import { HandleGridBody } from "components/common/HandleGridBody";
import { getActiveActivityTypes } from "services/activityTypeService";
import { useCurrentUser } from "services/currentUserService";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { chevronDownIcon } from "@progress/kendo-svg-icons";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useDoubleClick } from "components/common/hooks/SingleDoubleClick";
import { Button } from "@progress/kendo-react-buttons";
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import SearchTextBox from "components/SearchComponent";
import { FaFilter } from "react-icons/fa";
import filtersAppliedIcon from "../../assets/CaseFileIcons/FilterApplied.svg";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import styles from "./WorkDone.module.scss";
import MenuCell from "components/Activities/MenuCell";
import {
  ACTIVITY_DATA_ITEM_KEY,
  ACTIVITY_SELECTED_FIELD,
  buildMappedGridData,
  downloadBlobAsFile,
  getActivitiesToDelete,
  getActivitySubtypeStatus,
  getDeleteConfirmationMessage,
  getDeleteSuccessMessage,
  mergeDuplicateActivityData,
  resolveDuplicateActivityId,
  getRowStyle,
  getSelectedDocumentIds,
  getSelectedDocumentsForShare,
  getStatusClass,
  parseDownloadFilename,
  truncateFileName,
} from "components/Activities/activityUtils";
import ShareDocumentModal from "../CaseFile/ShareDocumentModal";
import ConfirmationDialog from "components/common/ConfirmationDialog";
import ESigning from "../CaseFile/ESigning";
import CaseActivityForm from "components/Activities/CaseActivityForm";
import ChitRequest from "pages/ChitRequest/ChitRequest";
import BillPostingModal from "pages/Bills/BillRequestModal.jsx";
import { isNonEmptyBillResourceId } from "pages/Bills/billReportResourceId";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { clearMattersBalances } from "actions/matters.action";
import ActionbarSkelton from "components/common/Loaders/ActionbarSkelton";
import { GRID_PAGE_SIZES } from "components/common/GridComponents";
import { FilterComponent } from "components/common/FiltersComponent";

const DEFAULT_PANES = [
  {
    collapsible: true,
  },
  {
    size: "0px",
  },
];

const WorkDone = () => {
  const dispatch = useDispatch();
  const getDynamicDocOpenPanes = () => [
    {
      collapsible: true,
    },
    {
      size: "40%",
      min: "500px",
      collapsible: false,
    },
  ];
  const idGetter = getter(ACTIVITY_DATA_ITEM_KEY);
  const { data: user } = useCurrentUser();
  const searchRef = useRef(null);
  const filterAnchorRef = useRef(null);
  const filterContentRef = useRef(null);
  const filterPopupRef = useRef(null);

  const [activityTypes, setActivityTypes] = useState([]);
  const [selectedState, setSelectedState] = useState({});
  const [paneDocument, setPaneDocument] = useState([]);
  const [panes, setPanes] = useState(DEFAULT_PANES);
  const [loader, setLoader] = useState(true);
  const [currentMatterContext, setCurrentMatterContext] = useState({});
  const [updateFilter, setUpdateFilter] = useState(false);
  const [typeID, setTypeID] = useState({ name: "ALL", activityTypeID: "" });
  const [loaded, setLoaded] = useState(false);
  const [allowAccessData, setAllowAccessData] = useState({});
  const [filterClicked, setFilterClicked] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [actionBarLoading, setActionBarLoading] = useState(true);

  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const INITIAL_FILTER_STATE = {
    branchId: {
      branchName: "ALL",
      branchId: -2,
    },
    teamId: { teamName: "ALL", teamID: -2 },
    feeEarnerRef: {
      display: user?.display || "",
      userRef: user?.userRef || "",
    },
  };

  const [filterState, setFilterState] = useState(INITIAL_FILTER_STATE);
  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(today);
  const [fromDateChecked, setFromDateChecked] = useState(true);
  const [toDateChecked, setToDateChecked] = useState(false);

  // Temporary state for popup filter (only used when popup is open)
  const [tempFromDate, setTempFromDate] = useState(startOfMonth);
  const [tempToDate, setTempToDate] = useState(today);
  const [tempFromDateChecked, setTempFromDateChecked] = useState(true);
  const [tempToDateChecked, setTempToDateChecked] = useState(false);
  const [tempTypeID, setTempTypeID] = useState({
    name: "ALL",
    activityTypeID: "",
  });
  const [searchValue, setSearchValue] = useState("");
  const [isRefreshed, setIsRefreshed] = useState(false);
  const [list, setLists] = useState({
    data: [],
    total: 0,
  });

  const [viewActivity, setViewActivity] = useState();
  const [isView, setView] = useState(false);
  const [multiSel, setMultiSel] = useState(false);
  const [showShareDocument, setShowShareDocument] = useState(false);
  const [currentDoc, setCurrentDoc] = useState({});
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [eSigning, setESigning] = useState();
  const [addActivity, setAddActivity] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [droppedFilesActivity, setDroppedFilesActivity] = useState([]);
  const [chitRequestModal, setChitRequestModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [prefilledChitDocs, setPrefilledChitDocs] = useState([]);
  const [openMenuActivityId, setOpenMenuActivityId] = useState(null);
  const [billRequestModal, setBillRequestModal] = useState(false);
  const [billingRequestPayload, setBillingRequestPayload] = useState(null);

  const createState = (skip, take) => {
    let pagerSettings = {
      pageSizes: GRID_PAGE_SIZES,
    };
    return {
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  const [state] = useState(createState(0, 200));

  const [dataState, setDataState] = useState({
    take: 200,
    skip: 0,
    sort: [
      {
        field: "date",
        dir: "desc",
      },
    ],
  });

  useEffect(() => {
    if (user && allowAccessData.branches) {
      const userBranch = allowAccessData.branches?.find((branch) =>
        branch.teams?.some((team) =>
          team.feeEarners?.some((fe) => fe.userRef === user.userRef),
        ),
      );

      const userTeam = userBranch?.teams?.find((team) =>
        team.feeEarners?.some((fe) => fe.userRef === user.userRef),
      );

      setFilterState({
        branchId: {
          branchName: allowAccessData.accessAllBranches
            ? "All"
            : userBranch?.branchName || "ALL",
          branchId: allowAccessData.accessAllBranches
            ? -2
            : userBranch?.branchId || -2,
        },
        teamId: {
          teamName: allowAccessData.accessAllTeams
            ? "All"
            : userTeam?.teamName || "ALL",
          teamID: allowAccessData.accessAllTeams ? -2 : userTeam?.teamID || -2,
        },
        feeEarnerRef: {
          display: user?.display || "",
          userRef: user?.userRef || "",
        },
      });
    }
  }, [user, allowAccessData]);

  useEffect(() => {
    if (updateFilter) {
      setUpdateFilter(false);
    }
  }, [updateFilter]);

  useEffect(() => {
    if (!filterClicked) return;

    const handlePointerDown = (event) => {
      const anchorElement = filterAnchorRef.current;
      if (anchorElement && anchorElement.contains(event.target)) {
        return;
      }

      if (event.target?.closest?.(".k-calendar")) {
        return;
      }

      if (event.target?.closest?.(".k-popup")) {
        return;
      }

      const popupElement = filterPopupRef.current;
      const popupContainer = popupElement
        ? popupElement.closest(".k-animation-container")
        : null;
      const rect =
        popupContainer?.getBoundingClientRect?.() ||
        popupElement?.getBoundingClientRect?.();

      if (!rect) {
        setFilterClicked(false);
        return;
      }

      const { clientX, clientY } = event;
      const isInside =
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom;
      if (!isInside) {
        setFilterClicked(false);
      }
    };

    document.addEventListener("pointerdown", handlePointerDown, true);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown, true);
    };
  }, [filterClicked]);

  const onOpen = () => {
    setTempFromDate(fromDate);
    setTempToDate(toDate);
    setTempFromDateChecked(fromDateChecked);
    setTempToDateChecked(toDateChecked);
    setTempTypeID(typeID);
  };

  const getAccessRights = async () => {
    try {
      const data = await getAccessRightsData();
      setAllowAccessData(data?.data?.data || {});
    } catch (error) {}
  };

  const fetchActivityTypes = async () => {
    try {
      const types = await getActiveActivityTypes();
      setActivityTypes(types || []);
    } catch (error) {}
  };

  useEffect(() => {
    const loadActionBarData = async () => {
      setActionBarLoading(true);
      try {
        await Promise.all([getAccessRights(), fetchActivityTypes()]);
      } finally {
        setActionBarLoading(false);
      }
    };
    loadActionBarData();
  }, []);

  const showPaneFile = async (id, matterRef, matterId) => {
    setLoaded(false);
    try {
      if (!id) {
        setPaneDocument([]);
        setPanes(getDynamicDocOpenPanes());
        setCurrentMatterContext({});
        return;
      }
      const { data } = await getDocument(id);
      setPaneDocument([data.data]);
      setCurrentMatterContext({
        matterRef: matterRef || "",
        matterId: matterId || null,
      });
      setPanes(getDynamicDocOpenPanes());
    } catch (error) {
      setPaneDocument([]);
      setPanes(getDynamicDocOpenPanes());
      setCurrentMatterContext({});
    } finally {
      setLoaded(true);
    }
  };

  const showDocumentFile = (documentId, matterRef, matterId) => {
    if (!documentId) return;

    const encodedId = btoa(
      JSON.stringify({
        id: documentId,
        matterRef: matterRef || "",
        matterId: matterId || null,
      }),
    );

    const url = `/sa/document-viewer?id=${encodedId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleDownload = async (documentId, asPDF = false, fromDocView) => {
    setLoader(true);
    try {
      const selectedDocumentIds = getSelectedDocumentIds(
        selectedState,
        list?.data,
      );

      let response;
      let fileName;

      if (selectedDocumentIds.length > 1 && !fromDocView) {
        fileName = "work-done-documents.zip";
        response = await downloadDocumentsAsZip(fileName, selectedDocumentIds);
      } else if (selectedDocumentIds.length === 1 || documentId) {
        response = asPDF
          ? await downloadDocumentAsPDF(documentId || selectedDocumentIds[0])
          : await downloadDocument(documentId || selectedDocumentIds[0]);

        fileName = parseDownloadFilename(response, asPDF);
      } else {
        setLoader(false);
        return;
      }

      downloadBlobAsFile(response.data, fileName);
    } catch (error) {} finally {
      setLoader(false);
    }
  };

  const matterContextWithClosed = async (matterId, partial) => {
    if (!matterId) {
      return {
        matterRef: partial?.matterRef,
        matterId: partial?.matterId,
        closed: false,
      };
    }
    let closed = partial?.matterClosed ?? partial?.closed;
    if (closed === undefined || closed === null) {
      try {
        const { data } = await getMattersdetails(matterId);
        closed = data?.data?.closed;
      } catch (e) {
        closed = false;
      }
    }
    return {
      matterRef: partial?.matterRef,
      matterId,
      closed: Boolean(closed),
    };
  };

  const handleDuplicate = async (matterId, sourceActivity) => {
    const activityId = resolveDuplicateActivityId(sourceActivity);
    if (!matterId || !activityId) return;

    try {
      const { data } = await getMatterDocDuplicate(matterId, activityId);
      const sourceRow =
        typeof sourceActivity === "object" ? sourceActivity : null;
      const activityData = mergeDuplicateActivityData(data?.data, sourceRow);
      const mid = activityData?.matterId || matterId;

      setCurrentMatterContext(
        await matterContextWithClosed(mid, {
          matterRef: activityData?.matterRef,
          matterId: mid,
          matterClosed: activityData?.matterClosed,
          closed: activityData?.closed,
        }),
      );

      setViewActivity(activityData);
      setView(true);
      setIsDuplicate(true);
      setAddActivity(true);
    } catch (error) {}
  };

  const getDocumentEditorData = async (id, type) => {
    try {
      setLoader(true);
      const { data } = await getDocumentEditor(id, currentMatterContext.matterId);
      let editUrl = data?.data?.editURL;
      if (type === "Local") {
        let ext = "";
        if (paneDocument && paneDocument[0]) {
          const doc = paneDocument[0];
          if (doc.documentName) {
            ext = doc.documentName.split(".").pop().toLowerCase();
          }
        }
        if (["xls", "xlsx"].includes(ext)) {
          editUrl = `ms-excel:ofe|u|${editUrl}`;
        } else {
          editUrl = `ms-word:ofe|u|${editUrl}`;
        }
      }
      window.open(editUrl, "_blank");
      showPaneFile(
        id,
        currentMatterContext.matterRef,
        currentMatterContext.matterId,
      );
    } catch (error) {
      const statusCode = error?.response?.status;
      if (statusCode !== 460) {
      }
    } finally {
      setLoader(false);
    }
  };

  const handleActivityRowClick = async (activity) => {
    const matterId = activity?.matterId;
    const activityId = activity?.activityId;

    const fetchLatestActivity = async () => {
      if (!matterId || !activityId) return activity;
      try {
        const { data } = await getSingleMatterActivity(matterId, activityId);
        return data?.data ?? data ?? activity;
      } catch (error) {
        toast.error("Could not load the latest activity details.");
        return activity;
      }
    };

    if (activity.subType === "ChitRequest") {
      const latestActivity = await fetchLatestActivity();
      const chitId =
        latestActivity?.chitRequestId ??
        latestActivity?.chitId ??
        latestActivity?.subTypeId;
      if (!chitId) {
        return;
      }
      setSelectedActivity(latestActivity);
      setCurrentMatterContext(
        await matterContextWithClosed(latestActivity.matterId, {
          matterRef: latestActivity.matterRef,
          matterId: latestActivity.matterId,
          matterClosed: latestActivity.matterClosed,
          closed: latestActivity.closed,
        }),
      );
      setChitRequestModal(true);
      return;
    }

    if (activity.subType === "BillRequest") {
      const latestActivity = await fetchLatestActivity();
      const billRequestId = latestActivity?.subTypeId;
      if (!billRequestId) {
        return;
      }
      try {
        const response = await getBillingRequestDetails(billRequestId);
        const detailData = response?.data?.data;
        if (!detailData) {
          return;
        }
        const templateFromDetail = detailData.billTemplateResourceId;
        const payload = {
          ...latestActivity,
          ...detailData,
          matterRef:
            detailData.matterRef ||
            latestActivity.matterRef ||
            currentMatterContext.matterRef ||
            "",
        };
        if (isNonEmptyBillResourceId(templateFromDetail)) {
          payload.billTemplateResourceId = templateFromDetail;
        }
        setCurrentMatterContext(
          await matterContextWithClosed(payload.matterID ?? payload.matterId, {
            matterRef: payload.matterRef,
            matterId: payload.matterID ?? payload.matterId,
            matterClosed: latestActivity.matterClosed,
            closed: latestActivity.closed,
          }),
        );
        setBillingRequestPayload(payload);
        setBillRequestModal(true);
      } catch (error) {}
      return;
    }

    setSelectedState({
      [activity.activityId]: true,
    });
    setCurrentMatterContext(
      await matterContextWithClosed(activity.matterId, {
        matterRef: activity.matterRef,
        matterId: activity.matterId,
        matterClosed: activity.matterClosed,
        closed: activity.closed,
      }),
    );
    const latestActivity = await fetchLatestActivity();
    setViewActivity(latestActivity);
    setView(true);
    setAddActivity(true);
  };

  const setCurrentMatterForShare = (matterContext) => {
    setCurrentMatterContext(matterContext);
  };

  const getActivitiesData = () => {
    handleRefresh();
  };

  const handleDeleteClick = (dataItem) => {
    setDeleteConfirmation(
      getActivitiesToDelete(dataItem, selectedState, list?.data),
    );
  };

  const deleteMatterActivity = async (items) => {
    const itemsArray = Array.isArray(items) ? items : [items];
    try {
      setLoader(true);
      await Promise.all(
        itemsArray.map((data) =>
          updateMatterActivity(data.matterId, data.activityId, {
            ...data,
            active: false,
          }),
        ),
      );
      setDeleteConfirmation(false);
      setSelectedState({});
      toast.success(getDeleteSuccessMessage(itemsArray));
      handleRefresh();
    } catch (error) {} finally {
      setLoader(false);
    }
  };

  const onChange = (event) => {
    if (event?.newState[0].collapsed) {
      setPanes([
        {
          ...event?.newState[0],
        },
        {},
      ]);
      return;
    } else if (
      !event?.newState[1].collapsed &&
      !event?.newState[1].size &&
      paneDocument.length > 0
    ) {
      setPanes(getDynamicDocOpenPanes());
      return;
    } else {
      setPanes([...event.newState]);
    }
  };

  const handleAttachToChit = (docs) => {
    if (!docs?.length) return;
    setPrefilledChitDocs(docs);
    setSelectedActivity(null);
    setChitRequestModal(true);
  };

  const findRowWithDocForSelection = (oldState, newState) => {
    for (const id of Object.keys(newState)) {
      if (newState[id] && !oldState?.[id]) {
        const row = list?.data?.find((item) => item.activityId == id);
        if (row?.documentId) return row;
      }
    }
    const selectedIds = Object.keys(newState || {}).filter((k) => newState[k]);
    for (let i = selectedIds.length - 1; i >= 0; i--) {
      const row = list?.data?.find((item) => item.activityId == selectedIds[i]);
      if (row?.documentId) return row;
    }
    return null;
  };

  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: ACTIVITY_DATA_ITEM_KEY,
      });
      setMultiSel(true);
      setSelectedState(newSelectedState);

      const row = findRowWithDocForSelection(selectedState, newSelectedState);
      if (row) {
        showPaneFile(row.documentId, row.matterRef, row.matterId);
      } else {
        setPaneDocument([]);
        setPanes(DEFAULT_PANES);
        setCurrentMatterContext({});
      }
    },
    [selectedState, list?.data],
  );

  const onHeaderSelectionChange = useCallback(
    (event) => {
      const checkboxElement = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState = {};
      event.dataItems.forEach((item) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
    },
    [idGetter],
  );

  const dataStateChange = (e) => {
    const nextSort = e.dataState.sort;
    const prevSortField = dataState.sort?.[0]?.field ?? "date";

    if (
      nextSort !== undefined &&
      e.dataState.skip !== 0 &&
      dataState.sort !== nextSort
    ) {
      setDataState({ ...e.dataState, skip: 0 });
    } else if (nextSort && nextSort[0] === undefined) {
      setDataState({
        ...e.dataState,
        sort: [
          {
            field: prevSortField,
            dir: "asc",
          },
        ],
      });
    } else {
      setDataState(e.dataState);
    }
    setUpdateFilter(true);
  };

  const TypeCell = (prop) => {
    const handleTypeClick = (e) => {
      e.stopPropagation();
      handleActivityRowClick(prop.dataItem);
    };

    return (
      <td className="fs-sm wrap-text">
        <u style={{ cursor: "pointer" }} onClick={handleTypeClick}>
          {prop.dataItem.type}
        </u>
      </td>
    );
  };

  const DateCell = (props) => {
    const dateField = props.dataItem[props.field];

    if (dateField) {
      const dt = new Date(dateField);
      const dateStr = dt.toLocaleDateString("en-GB");
      const timeStr = dt.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return (
        <td
          onClick={(e) => {
            e.stopPropagation();
            setSelectedState({
              [props.dataItem.activityId]: true,
            });
            showPaneFile(
              props.dataItem?.documentId,
              props.dataItem?.matterRef,
              props.dataItem?.matterId,
            );
          }}
          className={`fs-sm ${props.className}`}>
          <div className="text-nowrap">{dateStr}</div>
          <div className="text-nowrap">{timeStr}</div>
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  const DocumentCell = (e) => {
    const { documentId, documentName, matterRef, matterId } = e.dataItem;

    const hybridClick = useDoubleClick(
      () => showDocumentFile(documentId, matterRef, matterId),
      () => {
        setSelectedState({
          [e.dataItem.activityId]: true,
        });
        showPaneFile(documentId, matterRef, matterId);
      },
    );

    return documentId ? (
      <td className={e.className ?? ""} style={e.style} onClick={hybridClick}>
        <div role="button" className="d-flex">
          {fileIcon(documentName)}
          <span className="ps-2 fs-sm d-lg-none d-xl-block">
            {truncateFileName(documentName)}
          </span>
          <span className="ps-2 fs-sm d-xl-none d-lg-block">
            {documentName?.split(".").pop()}
          </span>
        </div>
      </td>
    ) : (
      <td />
    );
  };

  const EmailCell = (props) => {
    const { emailFrom, emailTo, documentId, activityId, matterRef, matterId } =
      props.dataItem;

    return (
      <td
        className={`fs-sm wrap-text ${props.className}`}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedState({
            [activityId]: true,
          });
          showPaneFile(documentId, matterRef, matterId);
        }}>
        <div className="text-nowrap">{emailFrom}</div>
        <div className="text-nowrap">{emailTo}</div>
      </td>
    );
  };

  const DetailsCell = (props) => {
    const activity = props.dataItem;
    const status = getActivitySubtypeStatus(activity);

    const { documentId, matterRef, matterId, activityId } = activity;

    return (
      <td
        onClick={(e) => {
          e.stopPropagation();
          setSelectedState({
            [activityId]: true,
          });
          if (documentId) {
            showPaneFile(documentId, matterRef, matterId);
          }
        }}
        className={`wrap-text ${props.className} cursor-default`}>
        <div className="text-wrap">
          {status && (
            <span
              className={`me-2 badge ${getStatusClass(status)}`}
              style={{
                padding: "0.50em 0.75em 0.35em",
              }}
            >
              {status}
            </span>
          )}
          {activity?.details}
        </div>
      </td>
    );
  };

  const MatterRefCell = (prop) => {
    return <td className="fs-sm">{prop.dataItem.matterRef || ""}</td>;
  };

  const dataReceived = (data) => {
    if (data) {
      setLists(data);
      setLoader(false);
    }
  };

  const handleRefresh = () => {
    setDataState({
      ...dataState,
      skip: 0,
    });
    setSelectedState({});
    setPaneDocument([]);
    setPanes(DEFAULT_PANES);
    setCurrentMatterContext({});
    setIsRefreshed(!isRefreshed);
    setUpdateFilter(true);
  };

  const handleSearchChange = (value) => {
    setSearchValue(value || "");
    setUpdateFilter(true);
  };

  const updateFilterValues = () => {
    setFromDate(tempFromDate);
    setToDate(tempToDate);
    setFromDateChecked(tempFromDateChecked);
    setToDateChecked(tempToDateChecked);
    setTypeID(tempTypeID);

    setUpdateFilter(true);
    setFilterClicked(false);
  };

  useEffect(() => {
    const isFromDateDifferent =
      fromDateChecked &&
      fromDate &&
      (fromDate.getFullYear() !== startOfMonth.getFullYear() ||
        fromDate.getMonth() !== startOfMonth.getMonth() ||
        fromDate.getDate() !== startOfMonth.getDate());

    const isToDateSet = toDateChecked && toDate !== null;

    const isTypeSet =
      typeID?.activityTypeID !== "" && typeID?.activityTypeID !== undefined;

    const filterStatus = isFromDateDifferent || isToDateSet || isTypeSet;
    setFilterApplied(filterStatus);
  }, [fromDate, toDate, fromDateChecked, toDateChecked, typeID, startOfMonth]);

  const handleFilterReset = () => {
    const resetDate = startOfMonth;
    const resetType = { name: "ALL", activityTypeID: "" };

    // Reset both actual and temporary values
    setFromDate(resetDate);
    setToDate(today);
    setFromDateChecked(true);
    setToDateChecked(false);
    setTypeID(resetType);
    setTempFromDate(resetDate);
    setTempToDate(today);
    setTempFromDateChecked(true);
    setTempToDateChecked(false);
    setTempTypeID(resetType);
    setUpdateFilter(true);
  };

  const activityTypesWithAll = useMemo(
    () => [{ name: "ALL", activityTypeID: "" }, ...(activityTypes || [])],
    [activityTypes],
  );

  const mappedData = buildMappedGridData(list, selectedState, idGetter);

  return (
    <div className="activity-grid d-flex flex-column h-100 px-4">
      {actionBarLoading ? (
        <ActionbarSkelton length={3} />
      ) : (
        <div
          className={`d-flex align-items-end gap-2 py-3 justify-content-between ${styles.actionBarRow}`}>
          <div className={`d-flex gap-2 align-items-end ${styles.actionBarFilters}`}>
            <FilterComponent
              allowAccessData={allowAccessData}
              inlineLayout={true}
              disabledFeeEarner={false}
              updateFilters={(filters) => {
                setFilterState({
                  branchId: { 
                    branchName: allowAccessData.branches?.find(b => b.branchId === filters.branch)?.branchName || "ALL",
                    branchId: filters.branch 
                  },
                  teamId: { 
                    teamName: allowAccessData.branches?.find(b => b.branchId === filters.branch)?.teams?.find(t => t.teamID === filters.teamId)?.teamName || "ALL",
                    teamID: filters.teamId 
                  },
                  feeEarnerRef: {
                    display: filters.feeEarnerRef === "ALL" ? "ALL" : 
                      allowAccessData.branches?.find(b => b.branchId === filters.branch)?.teams?.find(t => t.teamID === filters.teamId)?.feeEarners?.find(fe => fe.userRef === filters.feeEarnerRef)?.display || filters.feeEarnerRef,
                    userRef: filters.feeEarnerRef
                  }
                });
                setUpdateFilter(true);
              }}
            />
            <div className={`gap-2 align-items-end ${styles.inlineFiltersWrap}`}>
              <div className={styles.filterItem}>
                <Label>Activity Type</Label>
                <ComboBox
                  style={{ maxWidth: "180px", minWidth: "150px" }}
                  data={activityTypesWithAll}
                  textField="name"
                  dataItemKey="activityTypeID"
                  value={typeID}
                  svgIcon={chevronDownIcon}
                  onChange={(e) => {
                    setTypeID(e.value || { name: "ALL", activityTypeID: "" });
                    setUpdateFilter(true);
                  }}
                />
              </div>

              <div className={styles.filterItem}>
                <div>
                  <Label editorId={"from"} className="me-5 pe-5">
                    From
                  </Label>
                  <Label editorId={"to"} className="ms-4 ps-1">
                    To
                  </Label>
                </div>
                <div className="date-form-to-wrapper">
                  <Checkbox
                    className="ms-2 mb-auto"
                    value={fromDateChecked}
                    onChange={(e) => {
                      setFromDateChecked(e.value);
                      fromDate && setUpdateFilter(true);
                    }}
                  />
                  <div className="from">
                    <DatePicker
                      id="from"
                      className="date-picker pe-2"
                      format="dd/MM/yyyy"
                      value={fromDate}
                      onChange={(e) => {
                        setFromDate(e.value);
                        setFromDateChecked(true);
                        setUpdateFilter(true);
                      }}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                  <div className="divider m-1"></div>
                  <Checkbox
                    className="ms-2 mt-auto mb-auto"
                    value={toDateChecked}
                    onChange={(e) => {
                      setToDateChecked(e.value);
                      toDate && setUpdateFilter(true);
                    }}
                  />
                  <div className="to">
                    <DatePicker
                      id="to"
                      className="date-picker pe-2"
                      format="dd/MM/yyyy"
                      value={toDate}
                      onChange={(e) => {
                        setToDate(e.value);
                        setToDateChecked(true);
                        setUpdateFilter(true);
                      }}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex gap-1 align-items-end">
            <div
              style={{
                flex: "1 1 0%",
                minWidth: "180px",
                maxWidth: "260px",
              }}>
              <SearchTextBox
                width="100%"
                height="40px"
                ref={searchRef}
                changeFilterValue={handleSearchChange}
              />
            </div>
            <div
              ref={filterAnchorRef}
              onClick={() => setFilterClicked(!filterClicked)}
              className={styles.filterBtnWrap}>
              {!filterApplied ? (
                <Button className={`common-btn ${styles.customBtn}`}>
                  <FaFilter color="white" size={16} />
                </Button>
              ) : (
                <Button className={`common-btn ${styles.customBtn}`}>
                  <img
                    src={filtersAppliedIcon}
                    alt="Filters Applied"
                    width={25}
                    height={25}
                  />
                </Button>
              )}
            </div>
            <Button
              className={`common-btn  ${styles.customBtn}`}
              svgIcon={refreshIcon}
              onClick={handleRefresh}
              title="Refresh"
            />
          </div>
        </div>
      )}
      <div className="h-100 flex-grow-1" style={{ minHeight: 0 }}>
        <Splitter
          panes={panes}
          onChange={onChange}
          onBarToggle={() => {
            if (panes[0].collapsed) {
              setPanes(getDynamicDocOpenPanes());
            } else {
              setPanes([
                {
                  collapsed: true,
                },
                {},
              ]);
            }
          }}
          className={`workflow-splitter border-0 h-100 ${
            (() => {
              const sz = panes[1]?.size;
              const open = sz && sz !== "0px" && sz !== "0" && sz !== 0;
              return !open ? styles["hide-splitbar"] : "";
            })()
          }`}>
          <Grid
            {...dataState}
            data={mappedData}
            sortable={true}
            dataItemKey={ACTIVITY_DATA_ITEM_KEY}
            selectedField={ACTIVITY_SELECTED_FIELD}
            selectable={{
              enabled: true,
              drag: false,
              cell: false,
              mode: "multiple",
            }}
            onDataStateChange={dataStateChange}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            className="h-100 overflow-auto grid-row-select casefile_outlook_grid grid-minwidth-col6-150"
            pageable={state.pageable}
            pageSize={state.pageSize}
            rowRender={(row, props) => {
              const style = getRowStyle(props.dataItem, activityTypes);
              return React.cloneElement(row, {
                style: { ...row.props.style, ...style },
              });
            }}>
            <GridNoRecords>
              {loader ? (
                <div style={{ height: "100px" }}></div>
              ) : (
                mappedData.data &&
                mappedData.data.length === 0 &&
                "No record available"
              )}
            </GridNoRecords>
            <GridColumn
              field={ACTIVITY_SELECTED_FIELD}
              width="50px"
              headerCell={() => <></>}
              headerSelectionValue={
                mappedData?.data?.findIndex(
                  (item) => !selectedState[idGetter(item)],
                ) === -1
              }
            />
            <GridColumn
              field="type"
              title="Type"
              cell={TypeCell}
              width="120px"
              className="fs-sm"
            />
            <GridColumn
              field="date"
              title="Date"
              cell={DateCell}
              width="100px"
              className="p-1 cursor-default"
            />
            <GridColumn
              field="feeEarnerRef"
              title="FE"
              width="60px"
              className="cursor-default"
            />
            <GridColumn
              field="matterRef"
              title="Matter Ref"
              cell={MatterRefCell}
              width="120px"
            />
            <GridColumn
              field="details"
              title="Details"
              cell={DetailsCell}
              className="text-wrap cursor-default"
            />
            <GridColumn
              field=""
              title=" "
              cell={(prop) => (
                <MenuCell
                  {...prop}
                  loaded={loaded}
                  setLoaded={setLoaded}
                  setSelectedState={setSelectedState}
                  selectedState={selectedState}
                  showPaneFile={showPaneFile}
                  multiSel={multiSel}
                  setMultiSel={setMultiSel}
                  setAddActivity={setAddActivity}
                  setViewActivity={setViewActivity}
                  setView={setView}
                  handleActivityRowClick={handleActivityRowClick}
                  showDocumentFile={showDocumentFile}
                  handleDownload={handleDownload}
                  getDocumentEditorData={getDocumentEditorData}
                  handleDuplicate={handleDuplicate}
                  setShowShareDocument={setShowShareDocument}
                  setCurrentDoc={setCurrentDoc}
                  onDeleteClick={handleDeleteClick}
                  setESigning={setESigning}
                  setCurrentMatterForShare={setCurrentMatterForShare}
                  matterId={prop?.dataItem?.matterId}
                  activities={list?.data}
                  onAttachToChit={handleAttachToChit}
                  isDocViewerOpen={
                    panes[1]?.size &&
                    panes[1]?.size !== "0px" &&
                    panes[1]?.size !== "0" &&
                    panes[1]?.size !== 0
                  }
                  openMenuActivityId={openMenuActivityId}
                  setOpenMenuActivityId={setOpenMenuActivityId}
                />
              )}
              width="40px"
            />
            <GridColumn
              title="Documents"
              cell={DocumentCell}
              width="120px"
              className="fs-sm px-1"
            />
            <GridColumn
              title="Email"
              cell={EmailCell}
              width="200px"
              className="fs-sm px-1 cursor-default"
            />
          </Grid>

          <div className="h-100">
            <DocumentViewer
              loader={loaded}
              onDownload={handleDownload}
              data={paneDocument}
              onRefresh={(id) =>
                showPaneFile(
                  id,
                  currentMatterContext.matterRef,
                  currentMatterContext.matterId,
                )
              }
              onScreenComponent={true}
              onClose={() => {
                setPanes(DEFAULT_PANES);
                setPaneDocument([]);
                setSelectedState({});
                setCurrentMatterContext({});
              }}
              onExpand={() => {
                if (panes[0].collapsed) {
                  setPanes(getDynamicDocOpenPanes());
                } else {
                  setPanes([
                    {
                      collapsed: true,
                    },
                    {},
                  ]);
                }
              }}
              onOpenInNewTab={(documentId) =>
                showDocumentFile(
                  documentId,
                  currentMatterContext.matterRef,
                  currentMatterContext.matterId,
                )
              }
              matterId={currentMatterContext.matterId}
              matter={currentMatterContext}
              component="workDone"
            />
          </div>
        </Splitter>
      </div>

      <Popup
        key={filterClicked ? "open" : "closed"}
        show={filterClicked}
        anchor={filterAnchorRef?.current}
        anchorAlign={{
          horizontal: "right",
          vertical: "bottom",
        }}
        popupAlign={{
          horizontal: "right",
          vertical: "top",
        }}
        onOpen={onOpen}>
        <div
          ref={(el) => {
            filterPopupRef.current = el;
            filterContentRef.current = el;
          }}
          role="menu"
          className="d-flex flex-column align-items-center">
          <div className="d-flex align-items-start flex-column p-2 mx-2">
            <Label className="mt-2">Set Filters</Label>
            <hr className="w-100 mt-2 " />
            <div style={{ width: "200px" }}>
              <div>
                <Label editorId="from" className="me-5 pe-5 mb-1">
                  From
                </Label>
              </div>
              <div className="date-form-to-wrapper">
                <Checkbox
                  className="ms-2 mt-auto mb-auto"
                  value={tempFromDateChecked}
                  onChange={(e) => {
                    setTempFromDateChecked(e.value);
                  }}
                />
                <div className="from">
                  <DatePicker
                    id="from"
                    className="date-picker margin-date"
                    format="dd/MM/yyyy"
                    value={tempFromDate}
                    onChange={(e) => {
                      setTempFromDate(e.value);
                      setTempFromDateChecked(true);
                    }}
                    toggleButton={CalenderCustomToggleButton}
                  />
                </div>
              </div>
              <div className="mt-2">
                <Label editorId="to" className=" mb-1">
                  To
                </Label>
                <div className="date-form-to-wrapper">
                  <Checkbox
                    className="ms-2 mt-auto mb-auto"
                    value={tempToDateChecked}
                    onChange={(e) => {
                      setTempToDateChecked(e.value);
                    }}
                  />
                  <div className="to">
                    <DatePicker
                      id="to"
                      className="date-picker margin-date "
                      format="dd/MM/yyyy"
                      value={tempToDate}
                      onChange={(e) => {
                        setTempToDate(e.value);
                        setTempToDateChecked(true);
                      }}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-2 d-flex flex-column ">
              <Label className="label mb-1">Type</Label>
              <DropDownList
                className="dropdown me-2"
                style={{ width: "200px" }}
                svgIcon={chevronDownIcon}
                textField="name"
                dataItemKey="activityTypeID"
                name="name"
                data={activityTypesWithAll}
                value={tempTypeID}
                onChange={(e) => {
                  setTempTypeID(e.value || { name: "ALL", activityTypeID: "" });
                }}
              />
            </div>

            <div className="d-flex my-2">
              <Button
                className="common-btn bgsecondary me-2 text-dark"
                onClick={handleFilterReset}>
                Reset
              </Button>
              <Button className="common-btn " onClick={updateFilterValues}>
                Update
              </Button>
            </div>
          </div>
        </div>
      </Popup>

      <HandleGridBody
        dataState={dataState}
        currentComponent="workDone"
        branchId={filterState.branchId?.branchId}
        teamId={filterState.teamId?.teamID}
        feeEarnerRef={filterState.feeEarnerRef?.userRef}
        fD={fromDateChecked && fromDate ? formatDateForAPI(fromDate) : null}
        tD={toDateChecked && toDate ? formatDateForAPI(toDate) : null}
        typeId={typeID.activityTypeID}
        onDataReceived={dataReceived}
        searchValue={searchValue}
        updateFilter={updateFilter}
        refresh={isRefreshed}
      />

      {showShareDocument && (
        <ShareDocumentModal
          onClose={() => setShowShareDocument(false)}
          selectedDocuments={getSelectedDocumentsForShare(
            selectedState,
            list?.data,
          )}
          matterId={currentMatterContext?.matterId}
          matter={currentMatterContext}
          currentDoc={currentDoc}
        />
      )}

      {deleteConfirmation && (
        <ConfirmationDialog
          content={getDeleteConfirmationMessage(deleteConfirmation)}
          onClickYes={() => {
            deleteMatterActivity(deleteConfirmation);
          }}
          onClickNo={() => setDeleteConfirmation(false)}
          onClose={() => setDeleteConfirmation(false)}
        />
      )}

      {eSigning && (
        <ESigning
          matterId={currentMatterContext?.matterId}
          title={"Select Contacts"}
          activityId={eSigning}
          onClose={() => setESigning()}
        />
      )}

      {addActivity && (
        <CaseActivityForm
          getActivitiesData={getActivitiesData}
          addFormText={`${currentMatterContext?.matterRef || ""} - Work Done`}
          droppedFilesActivity={droppedFilesActivity}
          viewActivity={viewActivity}
          feeEarnerRef={viewActivity?.fE || user?.userRef}
          matterDetails={{
            ...currentMatterContext,
            feeEarnerRef: viewActivity?.fE || user?.userRef,
          }}
          isView={isView}
          isDuplicate={isDuplicate}
          reference={currentMatterContext?.matterId}
          onMatterRefClickActions={() => {}}
          setshowMatterForm={() => {
            setViewActivity();
            setView(false);
            setDroppedFilesActivity([]);
            if (isDuplicate) setIsDuplicate(false);
            setAddActivity(false);
            setCurrentMatterContext({});
          }}
          isAddActivityBtn={false}
        />
      )}

      {chitRequestModal && (selectedActivity || prefilledChitDocs.length > 0) && (
        <ChitRequest
          cancelEdit={() => {
            setChitRequestModal(false);
            setSelectedActivity(null);
            setPrefilledChitDocs([]);
            dispatch(clearMattersBalances("Chit Request"));
          }}
          matter={
            selectedActivity
              ? {
                  matterId:
                    selectedActivity.matterId ??
                    selectedActivity.matterID ??
                    currentMatterContext.matterId,
                  matterRef:
                    selectedActivity.matterRef ?? currentMatterContext.matterRef,
                  feeEarnerRef: selectedActivity.feeEarnerRef,
                }
              : undefined
          }
          matterId={
            selectedActivity
              ? (selectedActivity.matterId ??
                  selectedActivity.matterID ??
                  currentMatterContext.matterId)
              : undefined
          }
          component="modal"
          chitRequestId={
            selectedActivity
              ? (selectedActivity?.chitRequestId ??
                  selectedActivity?.chitId ??
                  selectedActivity?.subTypeId)
              : undefined
          }
          unAllocated={Boolean(selectedActivity?.unallocatedOnly)}
          viewMode="dialog"
          activityData={selectedActivity || undefined}
          prefilledDocuments={prefilledChitDocs}
        />
      )}

      {billRequestModal && billingRequestPayload && (
        <BillPostingModal
          billingRequestPayload={billingRequestPayload}
          onClose={() => {
            setBillRequestModal(false);
            setBillingRequestPayload(null);
          }}
          onPostSuccess={() => {
            setBillRequestModal(false);
            setBillingRequestPayload(null);
            getActivitiesData();
          }}
        />
      )}
    </div>
  );
};

export default WorkDone;
